import React from 'react';

import Designers from '../Designers/Designers';

const ProjectPros = props => {
  return <Designers pro={true} {...props} />;
};

export default ProjectPros;
